<div class="container">
    <div class="left-image">
        <img alt="workinsync" src="../../../../../../assets/left.svg">
    </div>
    <div class="content">
        <div class="logo">
            <img style="padding-right: 20px ;" alt="workinsync" class="mr-md" src="../../../../../../assets/mis.svg"/>
            <img style="padding-left: 20px ;" alt="workinsync" class="mr-md" src="../../../../../../assets/WIS-full.svg"/>
          </div>
        <div class="main">
            <span class="label">
                Logged Out
            </span>
            <span class="message">You have been successfully logged out.</span>
            <div class="links">
                <span class="link" (click)="login()">Login Again</span>
            </div>
        </div>
    </div>
    <div class="right-image">
        <img src="../../../../../../assets/right.svg">
    </div>
</div>